import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useField } from 'formik';
import { StyledOption } from '../../Form/Fields/MultiSelectInput';
import { Div } from '../../helpers/StyledUtils';
import Button from '../../base/Button';
import Divider from '../../base/Divider';
import Search from '../../Search';
import Text from '../../base/Text';
const MultiSelectFilter: React.FC<{
  name: string;
  title?: string;
  options?: {
    value: string;
    label: string;
  }[];
  placeholder?: string;
  in_dropdown?: boolean;
  hide_search?: boolean;
  onBack?: () => void;
}> = t0 => {
  const $ = _c(28);
  const {
    options,
    name,
    title,
    placeholder,
    in_dropdown,
    onBack,
    hide_search
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = {
      name
    };
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [, t2, t3] = useField(t1);
  const {
    value
  } = t2;
  const {
    setValue,
    setTouched
  } = t3;
  const [search_term, setSearchTerm] = useState("");
  let t4;
  bb0: {
    if (!search_term) {
      t4 = options;
      break bb0;
    }
    let t5;
    if ($[2] !== options || $[3] !== search_term) {
      t5 = options?.filter(o => o.label.toLowerCase().includes(search_term.toLowerCase()));
      $[2] = options;
      $[3] = search_term;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    t4 = t5;
  }
  const filtered_options = t4;
  let t5;
  if ($[5] !== hide_search || $[6] !== in_dropdown || $[7] !== onBack || $[8] !== placeholder || $[9] !== search_term || $[10] !== title) {
    t5 = in_dropdown ? <Div p={3} flex={{
      gap: 3,
      direction: "column"
    }}><Div flex={{
        align: "center",
        gap: 3
      }}><Button outline={true} small={true} icon="arrow_back" onClick={onBack} /><Text semi={true}>{title || "Filter"}</Text></Div><Search placeholder={placeholder || "Search..."} small={true} onChange={setSearchTerm} value={search_term} /></Div> : !hide_search && <Search placeholder={placeholder || "Search..."} small={true} borderless={true} onChange={setSearchTerm} value={search_term} focus={true} />;
    $[5] = hide_search;
    $[6] = in_dropdown;
    $[7] = onBack;
    $[8] = placeholder;
    $[9] = search_term;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== hide_search || $[13] !== in_dropdown) {
    t6 = (in_dropdown || !hide_search) && <Divider />;
    $[12] = hide_search;
    $[13] = in_dropdown;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      direction: "column"
    };
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      maxHeight: "300px",
      overflowY: "auto"
    };
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== filtered_options || $[18] !== setTouched || $[19] !== setValue || $[20] !== value) {
    t9 = filtered_options && filtered_options?.length > 0 ? filtered_options.map(o_0 => <StyledOption key={o_0.label} p={{
      x: 2,
      y: 1.5
    }} label={o_0.label} size="m" name={o_0.label} checked={value.includes(o_0.value)} onChange={e => {
      setValue(e.currentTarget.checked ? [...value, o_0.value] : value.filter(v => v !== o_0.value));
      setTouched(true);
    }} />) : <Div p={{
      x: 3,
      y: 3
    }}><Text muted={true}>No options</Text></Div>;
    $[17] = filtered_options;
    $[18] = setTouched;
    $[19] = setValue;
    $[20] = value;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <Div flex={t7} m={0} p={1} style={t8}>{t9}</Div>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t5 || $[26] !== t6) {
    t11 = <Div>{t5}{t6}{t10}</Div>;
    $[24] = t10;
    $[25] = t5;
    $[26] = t6;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
export default MultiSelectFilter;